import CitizenBasicStatistics from './CitizenBasicStatistics';
import MyPrices from '../../inspector/myPrices/MyPrices';

type RecentReportsProps = {
  t: (key: string) => string;
};

const RecentReports = ({ t }: RecentReportsProps) => {
  return (
    <div className="section mx-10">
      <h1 className="section-title">{t('recentReports')}</h1>      
      <CitizenBasicStatistics t={t}/>
      {/* <RecentReportsList /> */}
      <MyPrices triggeredFrom ="citizenPortal"/>
    </div>
  );
};

export default RecentReports;
